import { ListOfDataListItemResponse } from './Api/ListOfDataListItemResponse';

export class TypeEntity extends ListOfDataListItemResponse {
	public static tryCast(o: any): TypeEntity {
		const ret = new TypeEntity();
		return Object.assign(ret, o);
	}
}
